import { styled } from '@mui/material/styles';
import { Button as BaseButton } from 'components/buttons';

export const Button = styled(BaseButton)(({ theme }) => ({
  margin: '5px',
  padding: '7px',
  border: `2px solid ${theme.color.primary.main}`,
  boxShadow: 'none',
  minWidth: 'unset !important',
  width: '100%',
  div: {
    wordBreak: 'normal !important'
  }
}));
